import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Login from './pages/Login';
import Layout from './components/Layout/Layout';
import Dashboard from './pages/Dashboard';
import FactoryPage from './pages/FactoryPage';
import TypePage from './pages/TypePage';
import CalendarPage from './pages/CalendarPage';
import UploadPage from './pages/UploadPage';
import NotFound from './pages/NotFound';
import PrivateRoute from './components/Auth/PrivateRoute';

function App() {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="animate-pulse flex flex-col items-center">
          <img 
            src="/assets/images/logo-icon.png" 
            alt="Groupe Savoie" 
            className="w-16 h-16 mb-4" 
          />
          <p className="text-gray-600 dark:text-gray-300 font-medium">Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route 
        path="/login" 
        element={
          currentUser ? <Navigate to="/" /> : <Login />
        } 
      />
      
      <Route 
        path="/" 
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="usine/:factoryId" element={<FactoryPage />} />
        <Route path="type/:typeId" element={<TypePage />} />
        <Route path="calendrier" element={<CalendarPage />} />
        <Route path="upload" element={<UploadPage />} />
      </Route>
      
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;